import $ from 'jquery';
import { track } from '@trello/analytics';

import Confirm from 'app/scripts/views/lib/confirm.coffee';
import Dialog from 'app/scripts/views/lib/dialog.coffee';

import { maybeDisplayLimitsErrorOnCardOpen } from 'app/scripts/views/card/card-limits-error.coffee';

export const archiveCard = function(e: MouseEvent) {
  this.model.close();
  track('Card Detail', 'Sidebar', 'Archive Button', this.model.trackProperty());
};

export const unarchiveCard = function(e: MouseEvent) {
  const options = {
    $elem: $(e.target),
    hasAttachments: this.model.attachmentList.length > 0,
    destinationBoard: this.model.getBoard(),
    destinationList: this.model.getList(),
  };
  if (maybeDisplayLimitsErrorOnCardOpen(options)) {
    return;
  }
  track('Card Detail', 'Sidebar', 'Re-Open Button', this.model.trackProperty());
  this.model.reopen();
};

export const renderArchived = function() {
  const isArchived = this.model.get('closed') === true;
  this.$('.js-archive-card').toggleClass('hide', isArchived);
  this.$('.js-unarchive-card').toggleClass('hide', !isArchived);
  return this;
};

export const renderDelete = function() {
  const isArchived = this.model.get('closed') === true;
  const shouldShowDeleteButton = isArchived || !!this.model.get('isTemplate');
  this.$('.js-delete-card').toggleClass('hide', !shouldShowDeleteButton);
  return this;
};

export const deleteCardSidebar = function(e: MouseEvent) {
  Confirm.toggle('delete card', {
    elem: e.target,
    model: this.model,
    confirmBtnClass: 'negate',
    fxConfirm: (function(_this) {
      return function(confirmClickEvent: MouseEvent) {
        Dialog.hide();
        _this.model.destroy();
        return track('Card', 'Delete', undefined, _this.model.trackProperty());
      };
    })(this),
  });
  track(
    'Card Detail',
    'Sidebar',
    'Open Delete Confirm',
    this.model.trackProperty(),
  );
};
